import { put, call, all, takeLatest, debounce } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { notification } from 'antd'
import {
  HookActions,
  FETCH_HOOKS,
  START_HOOK_VALIDATION,
  START_SAVING_HOOK,
  FETCH_HOOK_INFO,
  START_DELETING_HOOK
} from './actions'
import { fetchHooks, validateHook, saveHook, fetchHookInfo, updateHook, deleteHook } from '../../api/hook'
import { HookValidationResult, Hook } from './types'
import { HOOKS } from '../../routes'

const VALIDATION_DEBOUNCE_TIME = 250

export function* loadHooks() {
  try {
    const { data } = yield call(fetchHooks)
    yield put(HookActions.fetchHooksSuccess(data))
  } catch (err) {
    // eslint-disable-next-line no-console
    yield console.log(err)
  }
}

export function* validateNewHook(action: ReturnType<typeof HookActions.startHookValidation>) {
  const { hook } = action.payload
  const { data }: { data: HookValidationResult } = yield call(validateHook, hook)
  yield put(HookActions.updateHookValidation(data))
}

export function* savingHook(action: ReturnType<typeof HookActions.startSavingHook>) {
  const { hook } = action.payload
  let data: Hook | null = null
  if (hook.id) {
    const response = yield call(updateHook, hook.id, hook)
    data = response.data
  } else {
    const response = yield call(saveHook, hook)
    data = response.data
  }
  if (data) {
    yield put(HookActions.savingHookSuccess(data))
    yield put(HookActions.resetNewHook())
    yield put(push(HOOKS))
  }
}

export function* deletingHook(action: ReturnType<typeof HookActions.startDeletingHook>) {
  try {
    const { data }: { data: { success: boolean } } = yield call(deleteHook, action.payload)
    if (data.success) {
      notification.success({
        message: 'Eliminazione Hook',
        description: 'Hook eliminato con successo'
      })
    } else {
      notification.error({
        message: 'Eliminazione Hook',
        description: "Non è stato possibile eliminare l' hook"
      })
    }
    yield call(loadHooks)
  } catch (error) {
    // error
  }
}

export function* fetchHook(action: ReturnType<typeof HookActions.fetchHookInfo>) {
  try {
    const { data }: { data: Hook } = yield call(fetchHookInfo, action.payload)
    yield put(HookActions.fetchHookInfoSuccess(data))
  } catch (err) {
    // error
  }
}

export function* rootSaga() {
  yield all([
    takeLatest(FETCH_HOOKS, loadHooks),
    takeLatest(START_SAVING_HOOK, savingHook),
    takeLatest(START_DELETING_HOOK, deletingHook),
    takeLatest(FETCH_HOOK_INFO, fetchHook),
    debounce(VALIDATION_DEBOUNCE_TIME, START_HOOK_VALIDATION, validateNewHook)
  ])
}
